module.exports = __webpack_public_path__ + "static/media/Chu_Manh_Hai.98e11851.jpeg";